/* eslint-disable */

import { crashReporterInterface, localPreferences, tracker } from 'app-components/utils/core';

// verify (dev mode) - checks value and if value=false then log the message + popup alert; returns value back!
// verify (release mode) - checks value and if value=false then log the message; returns value back!
// assert (dev mode) - checks value and if value=false then log the message + popup alert + track assert; returns value back!
// assert (release mode) - checks value and if value=false then log the message + track assert; returns value back!

// @ts-expect-error FIXME TS7016
import sprintfDefault from 'sprintf-js';
const { sprintf } = sprintfDefault;

// @ts-expect-error FIXME TS7006
const getDescription = (messageOrException, ...substitutions) => {
  let description;

  if (typeof messageOrException === 'string') {
    if (substitutions?.length) {
      description = sprintf(messageOrException, ...substitutions);
    } else {
      description = messageOrException;
    }
  } else if (String(messageOrException) !== '[object Object]') {
    description = String(messageOrException);
  } else {
    description = JSON.stringify(messageOrException, null, 2);
  }

  return description;
};

export const verify = <T>(assertion: T, messageOrException: string | any, ...substitutions: any[]): T | boolean => {
  if (!assertion) {
    console.assert(assertion, messageOrException, ...substitutions); // eslint-disable-line no-console

    const description = getDescription(messageOrException, ...substitutions);
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const suppressAssertPopups = localPreferences.getSuppressAssertPopups();
    if (!suppressAssertPopups) {
      const object = messageOrException === description ? substitutions?.[0] : undefined;
      // eslint-disable-next-line no-alert
      if (
        !window.confirm(
          `OK - ignore\
      \nCancel - abort/debug execution\
      \nUse 'dev menu > Crash > Suppress Asserts' to disable popups\
      \n\nassertion: ${description} ${object ? JSON.stringify(object, null, 2) : ''}`,
        )
      ) {
        debugger; // eslint-disable-line no-debugger
        // nodeAssert(assertion, description);
        return true;
      }
    }
/////////////

    tracker.track(tracker.events.assert, { description });
  }
  return assertion;
};

export const assert = <T>(assertion: T, messageOrException: string | any, ...substitutions: any[]): T | boolean => {
  const result = verify(assertion, messageOrException, ...substitutions);

  if (!result) {
    const description = getDescription(messageOrException, ...substitutions);
    const error = new Error(description);
    error.name = 'Assert';
    // @ts-expect-error FIXME TS7034
    let custom;
    const object = messageOrException === description ? substitutions?.[0] : messageOrException;
    if (typeof object === 'object') {
      // eslint-disable-next-line no-prototype-builtins
      if (Error.prototype.isPrototypeOf(object) && object.stack) {
        error.stack = object.stack; // use original error stack
      }
      custom = { ...object, ...substitutions };
      const keys = Object.getOwnPropertyNames(object);
      keys.forEach((key) => {
        // @ts-expect-error FIXME TS7005
        custom[key] = object[key];
      });
      //@ts-nocheck
      // eslint-disable-line guard-for-in,no-restricted-syntax
      for (const key in object) {
        custom[key] = object[key];
      }
    }
    crashReporterInterface.reportError(error, { custom }, { context: error.message });
  }

  return result;
};

if (typeof self === 'object') {
  // eslint-disable-line no-restricted-globals
  self.assert = assert; // eslint-disable-line no-restricted-globals
  self.verify = verify; // eslint-disable-line no-restricted-globals
}

declare global {
  function verify<T>(assertion: T, messageOrException: string | any, ...substitutions: any[]): T | boolean; // eslint-disable-line no-shadow
  function assert<T>(assertion: T, messageOrException: string | any, ...substitutions: any[]): T | boolean; // eslint-disable-line no-shadow
}
